// ProtectedRoute.jsx
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, getUserRolesFromToken } from "../dataContext/AuthContext";

/**
 * Same rule as before: a token must exist and carry one of `requiredRoles`.
 * Decided synchronously - AuthContext restores roles from localStorage in an effect, so on the
 * very first render we decode the stored token directly instead of waiting on a timer
 * (the old 100ms delay flashed a spinner on every navigation).
 */
const ProtectedRoute = ({ children, requiredRoles }) => {
    const { roles, token } = useAuth();
    const location = useLocation();

    const authToken = token || localStorage.getItem("jwtToken");
    const userRoles = Array.isArray(roles) && roles.length > 0
        ? roles
        : getUserRolesFromToken(authToken);

    const isAuthorized = !!authToken && requiredRoles.some(role => userRoles.includes(role));

    if (!isAuthorized) {
        return <Navigate to="/unauthorized" state={{ from: location.pathname }} replace />;
    }

    return children;
};

export default ProtectedRoute;
